export class PostalResponse {
    city: string;
    country: string;
    postalCode: string;
    stateAbbr: string;
    stateProvince: string;
    status: boolean;

    construct() {
        this.status = false;
    }
}

